import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6fd49af2&scoped=true&lang=pug"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd49af2",
  null
  
)

export default component.exports